import React, { useState, useEffect } from "react";
import { withRouter } from "./functions";
import { useLocation} from "react-router-dom";
import ReLogin from '../modalPopups/reLogin';

const AuthVerify = (props) => {

  const [modalShow, setModalShow] = useState(false);
  const location = useLocation()

  useEffect(() => {
    const loggedIn = localStorage.getItem("loggedIn");
    if (loggedIn) {        
        const expiretime = localStorage.getItem("exp");
        if (expiretime < Date.now() && location.pathname !== "/login") {
            setModalShow(true)
            //props.router.navigate("/login")
        }
    }
  },[props,location]);// eslint-disable-next-line

  const handleModalClose = (fromModal) => {
    //alert(fromModal.msg);
    setModalShow(false)
    props.router.navigate("/login");
  };

  return <div>
            <ReLogin
              show={modalShow}
              title="Your Session is logged out. Please login again to gain access"
              onHide={handleModalClose}
              reLogin={1}
            />
          </div>;
};

export default withRouter(AuthVerify);